var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.text ? '' : 'font-italic !important ', 'onlyReadData']},[_vm._v(" "+_vm._s(_vm.text ? _vm.text : _vm.$t("Не_указано"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }